export default {
    CONTROL: 0,
    VARIANT_1: 1,
    VARIANT_2: 2,
    VARIANT_3: 3,
    VARIANT_4: 4,
    VARIANT_5: 5,
};
